import { DropDownItem } from './common'

export function createDropDownItems(systemDefaultIsYes: boolean): DropDownItem[] {
  const systemDefaultYesLabel: string = 'System Default (Yes)'
  const systemDefaultNoLabel: string = 'System Default (No)'
  return [
    { label: systemDefaultIsYes
        ? systemDefaultYesLabel
        : systemDefaultNoLabel, value: null },
    { label: 'Yes', value: true },
    { label: 'No', value: false }
  ]
}
